import Link from 'next/link';
import React, { useEffect } from 'react';
import styles from '../styles/Error.module.scss';

interface ErrorProps {
  serverError?: boolean;
}

const ErrorComponent: React.FC<ErrorProps> = (props: any) => {
  const { serverError } = props;
  useEffect(() => {
    function randomNum() {
      'use strict';
      return Math.floor(Math.random() * 9) + 1;
    }
    let increaseTimer = 0
    const time = 30,
      selector3 = document.querySelector('.thirdDigit'),
      selector2 = document.querySelector('.secondDigit'),
      selector1 = document.querySelector('.firstDigit');
    const loop3: NodeJS.Timeout = setInterval(function () {
      'use strict';
      if (increaseTimer > 40) {
        clearInterval(loop3);
        if (selector3) selector3.textContent = serverError ? '5' : '4';
      } else {
        if (selector3) selector3.textContent = randomNum().toString();
        increaseTimer++;
      }
    }, time);
    const loop2: NodeJS.Timeout = setInterval(function () {
      'use strict';
      if (increaseTimer > 80) {
        clearInterval(loop2);
        if (selector2) selector2.textContent = '0';
      } else {
        if (selector2) selector2.textContent = randomNum().toString();
        increaseTimer++;
      }
    }, time);
    const loop1: NodeJS.Timeout = setInterval(function () {
      'use strict';
      if (increaseTimer > 100) {
        clearInterval(loop1);
        if (selector1) selector1.textContent = serverError ? '0' : '4';
      } else {
        if (selector1) selector1.textContent = randomNum().toString();
        increaseTimer++;
      }
    }, time);
  }, []);

  return (
    <div id="error-component" className={styles.main}>
      <div className={styles.error}>
        <div>
          <div className={'col-xs-12 text-center'}>
            <div className={styles.containerError404}>
              <div className={styles.clip}>
                <div className={styles.shadow}>
                  <span className={`${styles.digit} thirdDigit`}></span>
                </div>
              </div>
              <div className={styles.clip}>
                <div className={styles.shadow}>
                  <span className={`${styles.digit} secondDigit`}></span>
                </div>
              </div>
              <div className={styles.clip}>
                <div className={styles.shadow}>
                  <span className={`${styles.digit} firstDigit`}></span>
                </div>
              </div>
              <div className={styles.msg}>
                OH!<span className={styles.triangle}></span>
              </div>
            </div>
            <h2 className="h1">OOPS, SORRY WE CAN&apos;T FIND THAT PAGE!</h2>
            <h3>Either something went wrong or the page doesn&apos;t exist anymore.</h3>
            <div className={styles.btndiv}>
              <Link href='/'>
                <a className={`${styles.btnPrimary}`}>Back to home</a>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorComponent;
